package com.anjuros.website.templates.selection.components.contactform

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.language.ResKey
import com.anjuros.website.templates.selection.modules.Theme
import com.anjuros.website.templates.selection.styles.SuccessColumnWidthStyle
import com.anjuros.website.templates.selection.styles.SuccessFontStyle
import com.anjuros.website.templates.selection.util.Res
import com.anjuros.website.templates.template4.util.Template4Constants
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun SuccessContactMessage(
    modifier: Modifier = Modifier,
    isDemo: Boolean = false,
    showSuccess: Boolean,
    onClose: () -> Unit
) {


    if (showSuccess) {
        Box(
            modifier = modifier.then(SuccessColumnWidthStyle.toModifier())
                .fillMaxWidth()
                .backgroundColor(Colors.White)
                .border(
                    width = 2.px,
                    color = Theme.DarkBlue.rgb,
                    style = LineStyle.Solid
                )
                .zIndex(3.0)
        ) {
            Box(
                modifier = Modifier
                    .size(40.px)
                    .align(Alignment.TopEnd)
                    .cursor(Cursor.Pointer)

                    .onClick {
                        onClose()
                    }
            ) {

                Image(
                    modifier = Modifier.align(Alignment.Center),
                    src = Res.Icon.icon_x,
                    alt = "Close menu"
                )
            }

            Column(
                modifier = Modifier
                    .margin(30.px),
                verticalArrangement = Arrangement.Top,
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                P(
                    attrs = SuccessFontStyle.toModifier()
                        .fillMaxWidth(90.percent)
                        .fontFamily(Template4Constants.FONT_FAMILY)
                        .color(Theme.DarkBlue.rgb)
                        .textAlign(TextAlign.Center)
                        .fontSize(20.px)
                        .fontWeight(FontWeight.Bold)
                        .toAttrs()
                ) {
                    Text(
                        LocalText(
                            if (isDemo) {
                                ResKey.TEMPLATE_MIX_CONTACT_FORM_TITLE_SUCCESS_DEMO
                            } else ResKey.TEMPLATE_MIX_CONTACT_FORM_TITLE_SUCCESS
                        )
                    )

                }
                SuccessForm()
            }
        }
    }
}